import React from 'react';
import { useState } from 'react';
import JumboNavIdentifier from "@jumbo/components/JumboVerticalNavbar/JumboNavIdentifier";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import {SIDEBAR_VIEWS} from "@jumbo/utils/constants/layout";
import List from "@mui/material/List";
import PropTypes from 'prop-types';
import { useLocation , Link} from 'react-router-dom';
import CreateMatterModal from 'app/pages/Docgen/views/matters/create-matter/CreateMatterModal';

const JumboVerticalNavbar = ({items}) => {
    const {sidebarOptions} = useJumboLayoutSidebar();

    const isMiniAndClosed = React.useMemo(() => {
        return sidebarOptions?.view === SIDEBAR_VIEWS.MINI && !sidebarOptions?.open;
    }, [sidebarOptions.view, sidebarOptions.open]);

    const [createMatterModalOpen, setCreateMatterOpen] = useState(false);

    const location = useLocation();

    return (
        <>
        <List
            disablePadding
            sx={{
                mr: isMiniAndClosed ? 0 : 2,
                pb: 2
            }}
        >

            {
                items.map((item, index) => (
                    <JumboNavIdentifier translate item={item} key={index} />
                ))
            }       

        </List>

        {location.pathname.includes("docgen") && <Link
          className="btn btn-orange sidebar-top-btn" 
          style={{ fontSize: '100%' }}         
          onClick={() => {
            setCreateMatterOpen(true);
          }}
        >
          Create New Docket
        </Link>}
        
        <CreateMatterModal
        open={createMatterModalOpen}
        handleClose={() => setCreateMatterOpen(false)}
        />
        </>
    );
};

JumboVerticalNavbar.defaultProps = {
    items: PropTypes.array,
    translate: false
};

export default JumboVerticalNavbar;